export enum LicenseTier {
    BASIC = 'Basic',
}

export class LicenseTierModel {
  id: number;
  name: string;
  allowImportSurveyMonkey: boolean;
  allowImportTypeForm: boolean;
}



// WEBPACK FOOTER //
// ./src/app/models/license-tier/license-tier.model.ts